// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';

import reducers from './reducers';
import sagas from './sagas';

const middleware = createSagaMiddleware();

const store = createStore(reducers, composeWithDevTools(applyMiddleware(middleware)));

middleware.run(sagas);

export { store };
